import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SponsorshipPage } from './pages/SponsorshipPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-11" data-mp="stiu982fb1w1">
      <Routes data-id="element-12" data-mp="sry03jk0tkyp">
        <Route path="/" element={<App data-id="element-14" data-mp="sqwlx67pkicr" />} data-id="element-13" data-mp="sshi109o89cq" />
        <Route path="/sponsorship" element={<SponsorshipPage data-id="element-16" data-mp="wtj6qn5yp30g" />} data-id="element-15" data-mp="wukthowcbdy0" />
      </Routes>
    </BrowserRouter>;
}